<template>
  <div>
    <el-upload
      :name="formName"
      :data="{name: 'image'}"
      :on-exceed="exceedHandle"
      :limit="imageLimit"
      :action="actionUrl"
      :file-list="imgList"
      list-type="picture-card"
      :on-error="imageErrorHandle"
      :before-upload="imageBeforeUpload"
      :on-success="successHandle"
      :on-remove="removeHandle">
      <i class="el-icon-plus"></i>
    </el-upload>
  </div>
</template>

<script>
import { fileUploadUrl } from '@/config'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    imageLimit: {
      type: Number,
      default: 20,
    },
  },
  watch: {
    value(newVal) {
      this.imgList = newVal
    }
  },
  data() {
    return {
      formName: 'image',
      actionUrl: fileUploadUrl,
      imgList: this.value
    }
  },
  methods: {
    imageBeforeUpload(file) {
      const { size } = file

      if (size > 20 * 1024 * 1024) {
        this.$message.error('上传的图片超过20MB限制，请压缩后上传')
        return false
      }

      return true
    },

    exceedHandle() {
      this.$message.error('超出最大上传数量')
    },
    imageErrorHandle() {
      this.$message.error('文件上传失败')
    },
    successHandle(e) {
      const { data } = e

      const targetValue = [
        ...this.value,
        {
          url: data.url,
          file_code: data.file_code,
          file_name: data.file_name,
          original_name: data.original_name,

          name: data.original_name
        }
      ]

      // this.imgList = targetValue
      this.$emit('input', targetValue)
    },
    removeHandle(file, fileList) { // eslint-disable-line
      const targetValue = fileList.map(item => {
        return {
          // url: item.url,
          // file_code: item.file_code

          url: item.url,
          file_code: item.file_code,
          file_name: item.file_name,
          original_name: item.original_name,

          name: item.original_name
        }
      })

      this.$emit('input', targetValue)
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
